<div id="modal-mobile-app" [class.desktop-modal]="screensize().isdesktop" [class.is-safari]="isSafari">
  <rcl-modal
    id="modal-mobile-app-rcl-modal"
    [show]="showMobileAppAdModal"
    [mobileFullScreen]="false"
    [attr.aria-hidden]="!showMobileAppAdModal"
    (onClose)="showMobileAppAdModal = false"
    >
    <rcl-modal-content id="modal-mobile-app-rcl-modal__content" class="modal-dialog-frame" [attr.tabindex]="0" tabindex="0">
      <!-- Close button -->
      <button id="modal-mobile-app-rcl-modal__content__close" class="close-button" (click)="showMobileAppAdModal = false">
        <img id="modal-mobile-app-rcl-modal__content__close-icon" src="assets/images/close-icon.png" alt="Close" />
      </button>

      <!-- Desktop case -->
      @if (isDesktop()) {
        <div id="modal-mobile-app-rcl-modal__content__desktop" class="rcl-row left-container">
          <div class="rcl-col-md-8">
            <p
              id="modal-mobile-app-rcl-modal__content__desktop__title"
              class="rcl-h2 title modal-font-style"
              [class.royal-title]="isRoyal"
              [innerHTML]="formatLongHeader()"
            ></p>
            <!---->
            <p
              id="modal-mobile-app-rcl-modal__content__desktop__sub-title"
              class="rcl-h4 modal-font-style sub-title"
              [innerHTML]="formatSubTitle()"
            ></p>
            <div class="rcl-row no-margin">
              <div class="rcl-col-md-3 padding-style">
                <img
                  id="modal-mobile-app-rcl-modal__content__desktop__logo"
                  class="desktop-logo"
                  src="assets/images/{{ brand }}-app-icon.png"
                  alt="{{ brand }}"
                  />
              </div>
              <div class="rcl-col-md-8">
                <a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener" target="_blank" class="store-button">
                  <img class="download-img" src="assets/images/download-appstore.png" alt="App Store" />
                </a>
                <a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener" target="_blank" class="store-button">
                  <img class="download-img" src="assets/images/download-googleplay.png" alt="Google Play" />
                </a>
              </div>
            </div>
            <p
              id="modal-mobile-app-rcl-modal__content__desktop__footer"
              class="modal-font-style footer-note"
              [innerHTML]="bundle() && bundle()['app.modal.footnote'] ? bundle()['app.modal.footnote'] : ''"
            ></p>
          </div>
          <div id="modal-mobile-app-rcl-modal__content__desktop__phone-img" class="rcl-col-md-4">
            <div class="phone-image-container">
              <img
                id="modal-mobile-app-rcl-modal__content__desktop__phone-img__phone-brand"
                src="assets/images/phone-{{ brand }}-2x.png"
                alt="{{ brand }} Mobile App"
                class="phone-image"
                />
            </div>
          </div>
        </div>
      }

      @if (isMobile()) {
        <div id="modal-mobile-app-rcl-modal__content__desktop">
          <div class="rcl-row">
            <div class="rcl-col-md-12">
              <p
                id="modal-mobile-app-rcl-modal__content__mobile__short-header"
                class="title centered modal-font-style"
                [innerHTML]="formatShortHeader()"
              ></p>
              <div class="centered">
                <img
                  id="modal-mobile-app-rcl-modal__content__mobile__img-app-icon"
                  src="assets/images/{{ brand }}-app-icon.png"
                  alt="{{ brand }}"
                  />
              </div>
              <div class="centered">
                <p id="modal-mobile-app-rcl-modal__content__mobile__sub-title" class="rcl-h4" [innerHTML]="formatSubTitle()"></p>
              </div>
            </div>
          </div>
          <div class="rcl-row centered" [attr.tabindex]="0">
            <div class="rcl-col-sm-6 padding-style">
              <a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener" target="_blank" class="store-button">
                <img class="download-img-width" src="assets/images/download-appstore.png" alt="App Store" />
              </a>
            </div>
            <div class="rcl-col-sm-6 padding-style">
              <a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener" target="_blank" class="store-button">
                <img class="download-img-width" src="assets/images/download-googleplay.png" alt="Google Play" />
              </a>
            </div>
          </div>
          <div class="rcl-row centered">
            <div class="rcl-col-sm-12">
              <p
                id="modal-mobile-app-rcl-modal__content__mobile__footer"
                class="modal-font-style footer-note"
                [innerHTML]="bundle() && bundle()['app.modal.footnote']"
              ></p>
            </div>
          </div>
        </div>
      }

      <!-- Mobile case -->
      @if (device !== contents.DEVICE_TYPE.DESKTOP) {
        <div
          id="modal-mobile-app-rcl-modal__content__mobile"
          [class.mobile-content]="!screensize().isdesktop"
          [attr.tabindex]="0"
          >
          <div class="rcl-row">
            <div class="rcl-col-md-12">
              <p
                id="modal-mobile-app-rcl-modal__content__mobile__short-header"
                class="title centered modal-font-style"
                [innerHTML]="formatShortHeader()"
              ></p>
              <div class="centered">
                <img
                  id="modal-mobile-app-rcl-modal__content__mobile__img-app-icon"
                  src="assets/images/{{ brand }}-app-icon.png"
                  alt="{{ brand }}"
                  />
              </div>
              <div class="centered">
                <p id="modal-mobile-app-rcl-modal__content__mobile__sub-title" class="rcl-h4" [innerHTML]="formatSubTitle()"></p>
              </div>
            </div>
          </div>
          <div class="rcl-row centered" [attr.tabindex]="0">
            @if (isAppleDevice) {
              <div class="rcl-col-sm-12 padding-style">
                <a id="appstore" title="app-store" (click)="trackDeepLink(constants.OS_TYPE.IOS)" [href]="deepLinkUrl" class="store-button">
                  <img class="download-img-width" src="assets/images/download-appstore.png" alt="App Store" />
                </a>
              </div>
            }
            @if (isAndroidDevice) {
              <div class="rcl-col-sm-12 padding-style">
                <a
                  id="googleplay"
                  title="google-play"
                  (click)="trackDeepLink(constants.OS_TYPE.ANDROID)"
                  [href]="deepLinkUrl"
                  class="store-button"
                  >
                  <img class="download-img-width" src="assets/images/download-googleplay.png" alt="Google Play" />
                </a>
              </div>
            }
          </div>
          <div class="rcl-row centered">
            <div class="rcl-col-sm-12">
              <p
                id="modal-mobile-app-rcl-modal__content__mobile__footer"
                class="modal-font-style footer-note"
                [innerHTML]="bundle() && bundle()['app.modal.footnote'] ? bundle()['app.modal.footnote'] : ''"
              ></p>
            </div>
          </div>
        </div>
      }
    </rcl-modal-content>
  </rcl-modal>
</div>
